module.exports = __webpack_public_path__ + "media/audio_console_mobile_transition.bc19992a.mp4";